module.exports = __webpack_public_path__ + "img/cancun-bay-pool.be26b627.jpg";